/**
 * The Cispracs web app (the platform shell) frames Bunker as its Chat section
 * and sends people through Bunker's sign-in and back. Only these exact
 * origins are trusted for both: no subdomains, no other scheme or port.
 */
export const PLATFORM_HOSTS: readonly string[] = ['https://cispracs.ru', 'https://demo.cispracs.ru'];

const MAX_RETURN_URL = 512;

/**
 * A page of the platform shell that Bunker's sign-in may send the browser
 * back to, or null. The URL must be absolute https on an exact PLATFORM_HOSTS
 * origin, without credentials, control characters or backslashes.
 */
export function platformReturnUrl(raw: unknown): string | null {
  if (typeof raw !== 'string' || raw.length > MAX_RETURN_URL) return null;
  for (const ch of raw) {
    const code = ch.charCodeAt(0);
    if (code < 0x20 || code === 0x7f || ch === '\\') return null;
  }
  let url: URL;
  try {
    url = new URL(raw);
  } catch {
    return null;
  }
  if (url.username || url.password || !PLATFORM_HOSTS.includes(url.origin)) return null;
  return url.toString();
}
